// Study Abroad Navigation Architecture - Complete Data Specification
// All routes are prefixed with /study-abroad/ for isolation
//
// PHASE 1 / FEB-2026 — Hub-and-Spoke navigation refactor.
// The Study Destinations dropdown now exposes ONLY the 6 primary country
// hubs. Topical sub-routes (visa, APS, blocked account, scholarships,
// universities, intakes, accommodation, PR, jobs-after-masters) are
// reachable EXCLUSIVELY from inside each country hub page. This is a
// deliberate SEO + UX decision to:
//   • surface country hubs as the topical-authority parents
//   • prevent dropdown over-stuffing on mobile
//   • route Googlebot through the canonical Hub → Spoke crawl path
//   • eliminate cross-country sublink cannibalisation in the mega menu

export const studyDestinations = {
  columns: [
    {
      title: 'STUDY DESTINATIONS',
      links: [
        { label: 'Study in Germany',         path: '/study-abroad/germany/'   },
        { label: 'Study in United Kingdom',  path: '/study-abroad/uk/'        },
        { label: 'Study in Canada',          path: '/study-abroad/canada/'    },
        { label: 'Study in Australia',       path: '/study-abroad/australia/' },
        { label: 'Study in Ireland',         path: '/study-abroad/ireland/'   },
        { label: 'Study in New Zealand',     path: '/study-abroad/newzealand/' },
        { label: 'Study in Dubai / UAE',     path: '/study-abroad/dubai/'     },
      ],
    },
  ],
  quickLinks: [
    { label: 'Compare Destinations', path: '/study-abroad/compare/' },
    { label: 'Cost Calculator',      path: '/study-abroad/cost-calculator/' },
    { label: 'Visa Eligibility',     path: '/study-abroad/visa-eligibility/' },
  ],
};

export const universities = {
  columns: [
    {
      title: 'GERMANY UNIVERSITIES',
      links: [
        { label: 'IU International University', path: '/study-abroad/universities/germany/iu-international-university/' },
        { label: 'GISMA Business School', path: '/study-abroad/universities/germany/gisma-business-school/' },
        { label: 'SRH Berlin University', path: '/study-abroad/universities/germany/srh-berlin-university/' },
        { label: 'Arden University Germany', path: '/study-abroad/universities/germany/arden-university/' },
        { label: 'RWTH Aachen University', path: '/study-abroad/universities/germany/rwth-aachen-university/' },
        { label: 'Technical University of Munich', path: '/study-abroad/universities/germany/technical-university-of-munich/' },
      ],
    },
    {
      title: 'UK UNIVERSITIES',
      links: [
        { label: 'University of Hertfordshire', path: '/study-abroad/universities/uk/university-of-hertfordshire/' },
        { label: 'University of Oxford', path: '/study-abroad/universities/uk/university-of-oxford/' },
        { label: 'University of Cambridge', path: '/study-abroad/universities/uk/university-of-cambridge/' },
        { label: 'Imperial College London', path: '/study-abroad/universities/uk/imperial-college-london/' },
        { label: 'University College London', path: '/study-abroad/universities/uk/university-college-london/' },
        { label: 'London School of Economics', path: '/study-abroad/universities/uk/london-school-of-economics-and-political-science/' },
        { label: "King's College London", path: '/study-abroad/universities/uk/kings-college-london/' },
        { label: 'University of Manchester', path: '/study-abroad/universities/uk/university-of-manchester/' },
        { label: 'University of Warwick', path: '/study-abroad/universities/uk/university-of-warwick/' },
        { label: 'University of Edinburgh', path: '/study-abroad/universities/uk/university-of-edinburgh/' },
        { label: 'University of Bristol', path: '/study-abroad/universities/uk/university-of-bristol/' },
        { label: 'University of Birmingham', path: '/study-abroad/universities/uk/university-of-birmingham/' },
        { label: 'University of Leeds', path: '/study-abroad/universities/uk/university-of-leeds/' },
        { label: 'University of Nottingham', path: '/study-abroad/universities/uk/university-of-nottingham/' },
        { label: 'University of Southampton', path: '/study-abroad/universities/uk/university-of-southampton/' },
        { label: 'University of Sheffield', path: '/study-abroad/universities/uk/university-of-sheffield/' },
        { label: 'University of Glasgow', path: '/study-abroad/universities/uk/university-of-glasgow/' },
        { label: 'University of Liverpool', path: '/study-abroad/universities/uk/university-of-liverpool/' },
        { label: 'Newcastle University', path: '/study-abroad/universities/uk/newcastle-university/' },
        { label: 'Durham University', path: '/study-abroad/universities/uk/durham-university/' },
        { label: 'University of York', path: '/study-abroad/universities/uk/university-of-york/' },
        { label: 'University of Exeter', path: '/study-abroad/universities/uk/university-of-exeter/' },
        { label: 'Queen Mary University of London', path: '/study-abroad/universities/uk/queen-mary-university-of-london/' },
        { label: 'Cardiff University', path: '/study-abroad/universities/uk/cardiff-university/' },
        { label: "Queen's University Belfast", path: '/study-abroad/universities/uk/queens-university-belfast/' },
        { label: 'University of Bath', path: '/study-abroad/universities/uk/university-of-bath/' },
        { label: 'Loughborough University', path: '/study-abroad/universities/uk/loughborough-university/' },
        { label: 'University of Lancaster', path: '/study-abroad/universities/uk/university-of-lancaster/' },
        { label: 'University of Surrey', path: '/study-abroad/universities/uk/university-of-surrey/' },
        { label: 'University of Strathclyde', path: '/study-abroad/universities/uk/university-of-strathclyde/' },
        { label: 'University of Reading', path: '/study-abroad/universities/uk/university-of-reading/' },
        { label: 'University of Sussex', path: '/study-abroad/universities/uk/university-of-sussex/' },
        { label: 'University of Leicester', path: '/study-abroad/universities/uk/university-of-leicester/' },
        { label: 'University of Aberdeen', path: '/study-abroad/universities/uk/university-of-aberdeen/' },
        { label: 'University of East Anglia', path: '/study-abroad/universities/uk/university-of-east-anglia/' },
        { label: 'University of Dundee', path: '/study-abroad/universities/uk/university-of-dundee/' },
        { label: 'Heriot-Watt University', path: '/study-abroad/universities/uk/heriot-watt-university/' },
        { label: 'University of St Andrews', path: '/study-abroad/universities/uk/university-of-st-andrews/' },
        { label: 'Aston University', path: '/study-abroad/universities/uk/aston-university/' },
        { label: 'Brunel University London', path: '/study-abroad/universities/uk/brunel-university-london/' },
        { label: 'City, University of London', path: '/study-abroad/universities/uk/city-university-of-london/' },
        { label: 'Goldsmiths, University of London', path: '/study-abroad/universities/uk/goldsmiths-university-of-london/' },
        { label: 'Birkbeck, University of London', path: '/study-abroad/universities/uk/birkbeck-university-of-london/' },
        { label: 'Coventry University', path: '/study-abroad/universities/uk/coventry-university/' },
        { label: 'University of Bedfordshire', path: '/study-abroad/universities/uk/university-of-bedfordshire/' },
        { label: 'University of West London', path: '/study-abroad/universities/uk/university-of-west-london/' },
        { label: 'De Montfort University', path: '/study-abroad/universities/uk/de-montfort-university/' },
        { label: 'Leeds Beckett University', path: '/study-abroad/universities/uk/leeds-beckett-university/' },
        { label: 'Teesside University', path: '/study-abroad/universities/uk/teesside-university/' },
        { label: 'University of Greenwich', path: '/study-abroad/universities/uk/university-of-greenwich/' },
        { label: 'Northumbria University', path: '/study-abroad/universities/uk/northumbria-university/' },
        { label: 'Ulster University', path: '/study-abroad/universities/uk/ulster-university/' },
        { label: 'University of Central Lancashire', path: '/study-abroad/universities/uk/university-of-central-lancashire/' },
        { label: 'Staffordshire University', path: '/study-abroad/universities/uk/staffordshire-university/' },
        { label: 'University of Huddersfield', path: '/study-abroad/universities/uk/university-of-huddersfield/' },
        { label: 'University of Salford', path: '/study-abroad/universities/uk/university-of-salford/' },
        { label: 'Kingston University London', path: '/study-abroad/universities/uk/kingston-university-london/' },
        { label: 'Middlesex University London', path: '/study-abroad/universities/uk/middlesex-university-london/' },
        { label: 'University of East London', path: '/study-abroad/universities/uk/university-of-east-london/' },
        { label: 'University of Portsmouth', path: '/study-abroad/universities/uk/university-of-portsmouth/' },
        { label: 'Oxford Brookes University', path: '/study-abroad/universities/uk/oxford-brookes-university/' },
        { label: 'Manchester Metropolitan University', path: '/study-abroad/universities/uk/manchester-metropolitan-university/' },
        { label: 'Nottingham Trent University', path: '/study-abroad/universities/uk/nottingham-trent-university/' },
        { label: 'Sheffield Hallam University', path: '/study-abroad/universities/uk/sheffield-hallam-university/' },
        { label: 'University of Sunderland', path: '/study-abroad/universities/uk/university-of-sunderland/' },
        { label: 'Anglia Ruskin University', path: '/study-abroad/universities/uk/anglia-ruskin-university/' },
        { label: 'Birmingham City University', path: '/study-abroad/universities/uk/birmingham-city-university/' },
        { label: 'University of Chester', path: '/study-abroad/universities/uk/university-of-chester/' },
        { label: 'University of Derby', path: '/study-abroad/universities/uk/university-of-derby/' },
        { label: 'University of South Wales', path: '/study-abroad/universities/uk/university-of-south-wales/' },
        { label: 'Edinburgh Napier University', path: '/study-abroad/universities/uk/edinburgh-napier-university/' },
        { label: 'Glasgow Caledonian University', path: '/study-abroad/universities/uk/glasgow-caledonian-university/' },
        { label: 'Robert Gordon University', path: '/study-abroad/universities/uk/robert-gordon-university/' },
        { label: 'Bournemouth University', path: '/study-abroad/universities/uk/bournemouth-university/' },
        { label: 'University of Plymouth', path: '/study-abroad/universities/uk/university-of-plymouth/' },
        { label: 'University of Lincoln', path: '/study-abroad/universities/uk/university-of-lincoln/' },
        { label: 'University of Wolverhampton', path: '/study-abroad/universities/uk/university-of-wolverhampton/' },
        { label: 'Cardiff Metropolitan University', path: '/study-abroad/universities/uk/cardiff-metropolitan-university/' },
        { label: 'Swansea University', path: '/study-abroad/universities/uk/swansea-university/' },
        { label: 'Bangor University', path: '/study-abroad/universities/uk/bangor-university/' },
        { label: 'Aberystwyth University', path: '/study-abroad/universities/uk/aberystwyth-university/' },
        { label: 'University of the West of England', path: '/study-abroad/universities/uk/university-of-the-west-of-england/' },
        { label: 'Solent University', path: '/study-abroad/universities/uk/solent-university/' },
        { label: 'University of Brighton', path: '/study-abroad/universities/uk/university-of-brighton/' },
        { label: 'Canterbury Christ Church University', path: '/study-abroad/universities/uk/canterbury-christ-church-university/' },
        { label: 'Roehampton University London', path: '/study-abroad/universities/uk/roehampton-university-london/' },
        { label: "St Mary's University, Twickenham", path: '/study-abroad/universities/uk/st-marys-university-twickenham/' },
        { label: 'University of West of Scotland', path: '/study-abroad/universities/uk/university-of-west-of-scotland/' },
        { label: 'Buckinghamshire New University', path: '/study-abroad/universities/uk/buckinghamshire-new-university/' },
        { label: 'York St John University', path: '/study-abroad/universities/uk/york-st-john-university/' },
        { label: 'Bath Spa University', path: '/study-abroad/universities/uk/bath-spa-university/' },
        { label: 'University of Worcester', path: '/study-abroad/universities/uk/university-of-worcester/' },
        { label: 'London Business School', path: '/study-abroad/universities/uk/london-business-school/' },
        { label: 'The University of Law', path: '/study-abroad/universities/uk/the-university-of-law/' },
        { label: 'BPP University', path: '/study-abroad/universities/uk/bpp-university/' },
        { label: "Regent's University London", path: '/study-abroad/universities/uk/regents-university-london/' },
        { label: 'Arden University', path: '/study-abroad/universities/uk/arden-university/' },
        { label: 'GISMA Business School', path: '/study-abroad/universities/uk/gisma-business-school/' },
      ],
    },
    {
      title: 'DUBAI UNIVERSITIES',
      links: [
        { label: 'Abu Dhabi University', path: '/study-abroad/universities/dubai/abu-dhabi-university/' },
        { label: 'American University in Dubai', path: '/study-abroad/universities/dubai/american-university-in-dubai/' },
        { label: 'Amity Dubai Campus', path: '/study-abroad/universities/dubai/amity-dubai-campus/' },
        { label: 'Amity Education Group', path: '/study-abroad/universities/dubai/amity-education-group/' },
        { label: 'Bath Spa University Dubai', path: '/study-abroad/universities/dubai/bath-spa-university-dubai-campus/' },
        { label: 'Birmingham City University Dubai', path: '/study-abroad/universities/dubai/birmingham-city-university-dubai-campus/' },
        { label: 'Bradford University Dubai', path: '/study-abroad/universities/dubai/bradford-university-dubai-campus/' },
        { label: 'Curtin University Dubai', path: '/study-abroad/universities/dubai/curtin-university-dubai/' },
        { label: 'De Montfort University Dubai', path: '/study-abroad/universities/dubai/de-montfort-university-dubai/' },
        { label: 'Emirates Academy', path: '/study-abroad/universities/dubai/emirates-academy/' },
        { label: 'Emirates Aviation University', path: '/study-abroad/universities/dubai/emirates-aviation-university/' },
        { label: 'ESMOD Dubai', path: '/study-abroad/universities/dubai/esmod-dubai/' },
        { label: 'GEDU Global Education', path: '/study-abroad/universities/dubai/gedu-global-education/' },
        { label: 'Global Business Studies GBS', path: '/study-abroad/universities/dubai/global-business-studies-gbs-dubai/' },
        { label: 'Global University College', path: '/study-abroad/universities/dubai/global-university-college/' },
        { label: 'Heriot-Watt University Dubai', path: '/study-abroad/universities/dubai/heriot-watt-university-dubai-campus/' },
        { label: 'Hult International Business School', path: '/study-abroad/universities/dubai/hult-international-business-school-dubai-campus/' },
        { label: 'Istituto Marangoni Dubai', path: '/study-abroad/universities/dubai/istituto-marangoni-dubai/' },
        { label: 'Manipal Academy of Higher Education', path: '/study-abroad/universities/dubai/manipal-academy-of-higher-education/' },
        { label: 'Middlesex University Dubai', path: '/study-abroad/universities/dubai/middlesex-university-dubai-campus/' },
        { label: 'Murdoch University Dubai', path: '/study-abroad/universities/dubai/murdoch-university-dubai/' },
        { label: 'NYU Abu Dhabi', path: '/study-abroad/universities/dubai/new-york-university-abu-dhabi/' },
        { label: 'RIT Dubai Campus', path: '/study-abroad/universities/dubai/rit-dubai-campus/' },
        { label: 'S P Jain Dubai', path: '/study-abroad/universities/dubai/sp-jain-school-of-global-management-dubai-campus/' },
        { label: 'Schiller International Dubai', path: '/study-abroad/universities/dubai/schiller-international-university-dubai-campus/' },
        { label: 'UK College of Business & Computing', path: '/study-abroad/universities/dubai/uk-college-of-business-and-computing/' },
        { label: 'University of Birmingham Dubai', path: '/study-abroad/universities/dubai/university-of-birmingham-dubai/' },
        { label: 'University of Bolton', path: '/study-abroad/universities/dubai/university-of-bolton/' },
        { label: 'University of Europe Applied Sciences', path: '/study-abroad/universities/dubai/university-of-europe-for-applied-sciences-dubai-campus/' },
        { label: 'University of Stirling Dubai', path: '/study-abroad/universities/dubai/university-of-stirling-dubai/' },
        { label: 'University of Wollongong Dubai', path: '/study-abroad/universities/dubai/university-of-wollongong-dubai/' },
      ],
    },
  ],
  quickLinks: [
    { label: 'All Germany Universities', path: '/study-abroad/germany/public-universities/' },
    { label: 'All UK Universities', path: '/study-abroad/uk/best-universities/' },
    { label: 'All Dubai Universities', path: '/study-abroad/dubai/universities/' },
    { label: 'Compare Dubai Universities', path: '/study-abroad/dubai/compare/' },
  ],
};

// ─── Careers & Jobs Mega-Menu ─── (Phase 5: programmatic SEO expansion)
export const careersJobs = {
  columns: [
    {
      title: 'GERMANY',
      links: [
        { label: 'Mechanical Engineering Jobs', path: '/study-abroad/careers/germany/mechanical-engineering-jobs/' },
        { label: 'Automotive Engineering', path: '/study-abroad/careers/germany/automotive-engineering-jobs/' },
        { label: 'IT Jobs after Masters', path: '/study-abroad/careers/germany/it-jobs-after-masters/' },
        { label: 'AI Careers', path: '/study-abroad/careers/germany/artificial-intelligence-careers/' },
        { label: 'Data Science Careers', path: '/study-abroad/careers/germany/data-science-careers/' },
        { label: 'Cybersecurity Careers', path: '/study-abroad/careers/germany/cybersecurity-careers/' },
        { label: 'Mechatronics Careers', path: '/study-abroad/careers/germany/mechatronics-careers/' },
        { label: 'Robotics Careers', path: '/study-abroad/careers/germany/robotics-careers/' },
        { label: 'Nursing Careers', path: '/study-abroad/careers/germany/nursing-careers/' },
        { label: 'Healthcare Jobs', path: '/study-abroad/careers/germany/healthcare-jobs/' },
        { label: 'Renewable Energy', path: '/study-abroad/careers/germany/renewable-energy-careers/' },
        { label: 'Supply Chain Management', path: '/study-abroad/careers/germany/supply-chain-management-careers/' },
        { label: 'Biotechnology Careers', path: '/study-abroad/careers/germany/biotechnology-careers/' },
        { label: 'MBA Careers', path: '/study-abroad/careers/germany/mba-careers/' },
        { label: 'Public Health Careers', path: '/study-abroad/careers/germany/public-health-careers/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/germany/salary-after-ms/' },
        { label: 'Highest Paying Jobs', path: '/study-abroad/careers/germany/highest-paying-jobs-after-masters/' },
        { label: 'PR-Friendly Jobs', path: '/study-abroad/careers/germany/pr-jobs/' },
      ],
    },
    {
      title: 'UK',
      links: [
        { label: 'MBA Careers', path: '/study-abroad/careers/uk/mba-careers/' },
        { label: 'Jobs after MBA', path: '/study-abroad/careers/uk/jobs-after-mba/' },
        { label: 'Business Analytics', path: '/study-abroad/careers/uk/business-analytics-careers/' },
        { label: 'Finance Careers', path: '/study-abroad/careers/uk/finance-careers/' },
        { label: 'Fintech Careers', path: '/study-abroad/careers/uk/fintech-careers/' },
        { label: 'Law Careers', path: '/study-abroad/careers/uk/law-careers/' },
        { label: 'Nursing Careers', path: '/study-abroad/careers/uk/nursing-careers/' },
        { label: 'Public Health', path: '/study-abroad/careers/uk/public-health-careers/' },
        { label: 'Cybersecurity', path: '/study-abroad/careers/uk/cybersecurity-careers/' },
        { label: 'AI Careers', path: '/study-abroad/careers/uk/artificial-intelligence-careers/' },
        { label: 'Data Science', path: '/study-abroad/careers/uk/data-science-careers/' },
        { label: 'Healthcare Careers', path: '/study-abroad/careers/uk/healthcare-careers/' },
        { label: 'Cloud Computing', path: '/study-abroad/careers/uk/cloud-computing-careers/' },
        { label: 'Hospitality Management', path: '/study-abroad/careers/uk/hospitality-management-careers/' },
        { label: 'Supply Chain', path: '/study-abroad/careers/uk/supply-chain-management-careers/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/uk/salary-after-ms/' },
      ],
    },
    {
      title: 'CANADA',
      links: [
        { label: 'PR Courses', path: '/study-abroad/careers/canada/pr-courses/' },
        { label: 'Best Courses for PR', path: '/study-abroad/careers/canada/best-courses-for-pr/' },
        { label: 'Data Science Careers', path: '/study-abroad/careers/canada/data-science-careers/' },
        { label: 'AI Careers', path: '/study-abroad/careers/canada/artificial-intelligence-careers/' },
        { label: 'Cybersecurity', path: '/study-abroad/careers/canada/cybersecurity-careers/' },
        { label: 'Healthcare Careers', path: '/study-abroad/careers/canada/healthcare-careers/' },
        { label: 'Nursing Careers', path: '/study-abroad/careers/canada/nursing-careers/' },
        { label: 'Construction Mgmt', path: '/study-abroad/careers/canada/construction-management-careers/' },
        { label: 'Civil Engineering', path: '/study-abroad/careers/canada/civil-engineering-jobs/' },
        { label: 'Supply Chain', path: '/study-abroad/careers/canada/supply-chain-management-careers/' },
        { label: 'Hospitality Mgmt', path: '/study-abroad/careers/canada/hospitality-management-careers/' },
        { label: 'Early Childhood Education', path: '/study-abroad/careers/canada/early-childhood-education-careers/' },
        { label: 'MBA Careers', path: '/study-abroad/careers/canada/mba-careers/' },
        { label: 'Cloud Computing', path: '/study-abroad/careers/canada/cloud-computing-careers/' },
        { label: 'Computer Science', path: '/study-abroad/careers/canada/computer-science-careers/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/canada/salary-after-ms/' },
      ],
    },
    {
      title: 'AUSTRALIA',
      links: [
        { label: 'Skill Shortage Occupations', path: '/study-abroad/careers/australia/skill-shortage-occupations/' },
        { label: 'Best Courses for PR', path: '/study-abroad/careers/australia/best-courses-for-pr/' },
        { label: 'Nursing Careers', path: '/study-abroad/careers/australia/nursing-careers/' },
        { label: 'Civil Engineering', path: '/study-abroad/careers/australia/civil-engineering-jobs/' },
        { label: 'IT Careers', path: '/study-abroad/careers/australia/it-careers/' },
        { label: 'Cybersecurity', path: '/study-abroad/careers/australia/cybersecurity-careers/' },
        { label: 'Data Science', path: '/study-abroad/careers/australia/data-science-careers/' },
        { label: 'Public Health', path: '/study-abroad/careers/australia/public-health-careers/' },
        { label: 'Social Work', path: '/study-abroad/careers/australia/social-work-careers/' },
        { label: 'Early Childhood Edu', path: '/study-abroad/careers/australia/early-childhood-education-careers/' },
        { label: 'Construction Mgmt', path: '/study-abroad/careers/australia/construction-management-careers/' },
        { label: 'Hospitality Mgmt', path: '/study-abroad/careers/australia/hospitality-management-careers/' },
        { label: 'MBA Careers', path: '/study-abroad/careers/australia/mba-careers/' },
        { label: 'Mechanical Engineering', path: '/study-abroad/careers/australia/mechanical-engineering-jobs/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/australia/salary-after-ms/' },
      ],
    },
    {
      title: 'USA',
      links: [
        { label: 'AI Careers', path: '/study-abroad/careers/usa/artificial-intelligence-careers/' },
        { label: 'Computer Science', path: '/study-abroad/careers/usa/computer-science-careers/' },
        { label: 'Software Engineering', path: '/study-abroad/careers/usa/software-engineering-jobs/' },
        { label: 'Robotics Careers', path: '/study-abroad/careers/usa/robotics-careers/' },
        { label: 'Fintech Careers', path: '/study-abroad/careers/usa/fintech-careers/' },
        { label: 'Biotechnology', path: '/study-abroad/careers/usa/biotechnology-careers/' },
        { label: 'MBA Careers', path: '/study-abroad/careers/usa/mba-careers/' },
        { label: 'Data Science', path: '/study-abroad/careers/usa/data-science-careers/' },
        { label: 'Cloud Computing', path: '/study-abroad/careers/usa/cloud-computing-careers/' },
        { label: 'Cybersecurity', path: '/study-abroad/careers/usa/cybersecurity-careers/' },
        { label: 'UI/UX Design', path: '/study-abroad/careers/usa/ui-ux-design-careers/' },
        { label: 'Business Analytics', path: '/study-abroad/careers/usa/business-analytics-careers/' },
        { label: 'STEM Careers', path: '/study-abroad/careers/usa/stem-careers/' },
        { label: 'Highest Paying Jobs', path: '/study-abroad/careers/usa/highest-paying-jobs-after-masters/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/usa/salary-after-ms/' },
      ],
    },
    {
      title: 'IRELAND',
      links: [
        { label: 'Data Analytics Careers', path: '/study-abroad/careers/ireland/data-analytics-careers/' },
        { label: 'Pharmaceutical Sciences', path: '/study-abroad/careers/ireland/pharmaceutical-sciences-careers/' },
        { label: 'Cybersecurity Careers', path: '/study-abroad/careers/ireland/cybersecurity-careers/' },
        { label: 'Cloud Computing', path: '/study-abroad/careers/ireland/cloud-computing-careers/' },
        { label: 'Data Science', path: '/study-abroad/careers/ireland/data-science-careers/' },
        { label: 'Nursing Careers', path: '/study-abroad/careers/ireland/nursing-careers/' },
        { label: 'AI Careers', path: '/study-abroad/careers/ireland/artificial-intelligence-careers/' },
        { label: 'Software Engineering', path: '/study-abroad/careers/ireland/software-engineering-jobs/' },
        { label: 'Fintech Careers', path: '/study-abroad/careers/ireland/fintech-careers/' },
        { label: 'Computer Science', path: '/study-abroad/careers/ireland/computer-science-careers/' },
        { label: 'Salary after MS', path: '/study-abroad/careers/ireland/salary-after-ms/' },
      ],
    },
    {
      title: 'NEW ZEALAND',
      links: [
        { label: 'Nursing Careers', path: '/study-abroad/careers/new-zealand/nursing-careers/' },
        { label: 'Construction Mgmt', path: '/study-abroad/careers/new-zealand/construction-management-careers/' },
        { label: 'Civil Engineering', path: '/study-abroad/careers/new-zealand/civil-engineering-jobs/' },
        { label: 'Agriculture Careers', path: '/study-abroad/careers/new-zealand/agriculture-careers/' },
        { label: 'Hospitality Mgmt', path: '/study-abroad/careers/new-zealand/hospitality-management-careers/' },
        { label: 'IT Careers', path: '/study-abroad/careers/new-zealand/it-careers/' },
        { label: 'Healthcare Careers', path: '/study-abroad/careers/new-zealand/healthcare-careers/' },
        { label: 'Best Courses for PR', path: '/study-abroad/careers/new-zealand/best-courses-for-pr/' },
      ],
    },
    {
      title: 'DUBAI / UAE',
      links: [
        { label: 'MBA Careers', path: '/study-abroad/careers/dubai/mba-careers/' },
        { label: 'Hospitality Mgmt', path: '/study-abroad/careers/dubai/hospitality-management-careers/' },
        { label: 'Construction Mgmt', path: '/study-abroad/careers/dubai/construction-management-careers/' },
        { label: 'Supply Chain', path: '/study-abroad/careers/dubai/supply-chain-management-careers/' },
        { label: 'Fintech Careers', path: '/study-abroad/careers/dubai/fintech-careers/' },
        { label: 'Aviation Management', path: '/study-abroad/careers/dubai/aviation-management-careers/' },
        { label: 'IT Careers', path: '/study-abroad/careers/dubai/it-careers/' },
        { label: 'Healthcare Careers', path: '/study-abroad/careers/dubai/healthcare-careers/' },
      ],
    },
    {
      title: 'GLOBAL CAREER GUIDES',
      links: [
        { label: 'STEM Careers Abroad', path: '/study-abroad/careers/stem-careers-abroad/' },
        { label: 'Highest Paying Jobs after Masters', path: '/study-abroad/careers/highest-paying-jobs-after-masters/' },
        { label: 'Best Countries for Data Science', path: '/study-abroad/careers/best-countries-for-data-science-jobs/' },
        { label: 'Best Countries for Nursing', path: '/study-abroad/careers/best-countries-for-nursing-jobs/' },
        { label: 'Best Countries for MBA', path: '/study-abroad/careers/best-countries-for-mba-jobs/' },
        { label: 'Countries with PR after Study', path: '/study-abroad/careers/countries-with-pr-after-study/' },
        { label: 'Highest Paying Careers Abroad', path: '/study-abroad/careers/highest-paying-careers-abroad/' },
        { label: 'Best Courses to Study Abroad', path: '/study-abroad/careers/best-courses-to-study-abroad/' },
        { label: 'Jobs Abroad After Masters', path: '/study-abroad/careers/jobs-abroad-after-masters/' },
        { label: 'Salary after Masters Abroad', path: '/study-abroad/careers/salary-after-masters-abroad/' },
      ],
    },
  ],
};

export const studentVisa = [
  { label: 'Germany Student Visa Guide', path: '/study-abroad/germany/student-visa/' },
  { label: 'APS Certificate Germany Guide', path: '/study-abroad/germany/aps-certificate/' },
  { label: 'Germany PR after Study', path: '/study-abroad/germany/pr-after-study/' },
  { label: 'UK Student Visa Guide', path: '/study-abroad/uk/student-visa/' },
  { label: 'UK Student Visa Checklist', path: '/study-abroad/uk/student-visa/' },
  { label: 'UK PSW Visa Explained', path: '/study-abroad/uk/student-visa/' },
  { label: 'SOP Writing Guide', path: '/study-abroad/blog/how-to-write-sop-for-germany/' },
];

export const scholarshipsFinance = [
  { label: 'Scholarships in Germany', path: '/study-abroad/germany/scholarships/' },
  { label: 'Scholarships in UK', path: '/study-abroad/uk/scholarships/' },
  { label: 'Scholarships in Canada', path: '/study-abroad/canada/scholarships/' },
  { label: 'Education Loan Assistance', path: '/study-abroad/education-loan-assistance/' },
  { label: 'Scholarship Assessment', path: '/study-abroad/scholarship-assessment/' },
];

export const resources = {
  columns: [
    {
      title: 'STUDY ABROAD GUIDES',
      links: [
        { label: 'Cheapest Countries to Study Abroad', path: '/study-abroad/blog/cheapest-countries-to-study-abroad/' },
        { label: 'Best Countries for Indian Students', path: '/study-abroad/blog/best-countries-for-indian-students/' },
        { label: 'Best Masters Courses Abroad', path: '/study-abroad/blog/best-masters-courses-abroad/' },
        { label: 'Study Abroad Without IELTS', path: '/study-abroad/blog/study-abroad-without-ielts/' },
        { label: 'Germany vs UK', path: '/study-abroad/blog/germany-vs-uk-for-indian-students/' },
      ],
    },
    {
      title: 'PRACTICAL GUIDES',
      links: [
        { label: 'How to Write SOP', path: '/study-abroad/blog/how-to-write-sop-for-germany/' },
        { label: 'IELTS vs PTE', path: '/study-abroad/blog/ielts-vs-pte-comparison/' },
        { label: 'Cost of Living Germany vs UK', path: '/study-abroad/blog/cost-of-living-germany-vs-uk/' },
        { label: 'Student Accommodation Guide', path: '/study-abroad/blog/student-accommodation-abroad-guide/' },
      ],
    },
    {
      title: 'INTERACTIVE TOOLS',
      links: [
        { label: '📋 Free Profile Evaluation', path: '/study-abroad/free-profile-evaluation/' },
        { label: 'Compare Destinations', path: '/study-abroad/compare/' },
        { label: 'Cost Calculator', path: '/study-abroad/cost-calculator/' },
        { label: 'Visa Eligibility Checker', path: '/study-abroad/visa-eligibility/' },
        { label: 'Scholarship Assessment', path: '/study-abroad/scholarship-assessment/' },
        { label: 'Book Free Counselling', path: '/study-abroad/book-counselling/' },
      ],
    },
  ],
};

export const successStories = [
  { label: 'Student Success Stories', path: '/study-abroad/student-success-stories/' },
  { label: 'Video Testimonials', path: '/study-abroad/video-testimonials/' },
  { label: 'Our Visa Success Rate', path: '/study-abroad/visa-success-rate/' },
];

// P1 (Jun 2026): Knowledge Center — consolidates Student Visa + Scholarships & Finance + Resources
// into 4 intent pillars. ALL URLs unchanged. Old exports above retained for instant rollback.
// TODO: remove legacy exports (studentVisa, scholarshipsFinance, resources, successStories) after P1 stability window (~14 days post-publish).
export const knowledgeCenter = {
  columns: [
    {
      title: 'VISA & IMMIGRATION',
      links: [
        { label: 'Germany Student Visa Guide', path: '/study-abroad/germany/student-visa/' },
        { label: 'UK Student Visa Guide', path: '/study-abroad/uk/student-visa/' },
        { label: 'New Zealand Student Visa Guide', path: '/study-abroad/newzealand/student-visa-guide/' },
        { label: 'APS Certificate Germany Guide', path: '/study-abroad/germany/aps-certificate/' },
        { label: 'Germany PR after Study', path: '/study-abroad/germany/pr-after-study/' },
        { label: 'NZ Green List PR Guide', path: '/study-abroad/newzealand/green-list-pr-guide/' },
        { label: 'Visa Eligibility Checker', path: '/study-abroad/visa-eligibility/' },
      ],
    },
    {
      title: 'MONEY & FUNDING',
      links: [
        { label: 'Scholarships in Germany', path: '/study-abroad/germany/scholarships/' },
        { label: 'Scholarships in UK', path: '/study-abroad/uk/scholarships/' },
        { label: 'Scholarships in Canada', path: '/study-abroad/canada/scholarships/' },
        { label: 'Education Loan Assistance', path: '/study-abroad/education-loan-assistance/' },
        { label: 'Scholarship Assessment', path: '/study-abroad/scholarship-assessment/' },
        { label: 'Germany Blocked Account', path: '/study-abroad/germany/blocked-account/' },
        { label: 'NZ Cost of Study & Living', path: '/study-abroad/newzealand/cost-of-study-living/' },
        { label: 'Cost Calculator', path: '/study-abroad/cost-calculator/' },
      ],
    },
    {
      title: 'GUIDES & TOOLS',
      links: [
        { label: 'How to Write SOP', path: '/study-abroad/blog/how-to-write-sop-for-germany/' },
        { label: 'IELTS vs PTE', path: '/study-abroad/blog/ielts-vs-pte-comparison/' },
        { label: 'Student Accommodation Guide', path: '/study-abroad/blog/student-accommodation-abroad-guide/' },
        { label: 'Compare Destinations', path: '/study-abroad/compare/' },
        { label: 'Germany vs UK', path: '/study-abroad/blog/germany-vs-uk-for-indian-students/' },
        { label: 'Cost of Living Germany vs UK', path: '/study-abroad/blog/cost-of-living-germany-vs-uk/' },
      ],
    },
    {
      title: 'LEARN',
      links: [
        { label: 'Cheapest Countries to Study Abroad', path: '/study-abroad/blog/cheapest-countries-to-study-abroad/' },
        { label: 'Best Countries for Indian Students', path: '/study-abroad/blog/best-countries-for-indian-students/' },
        { label: 'Best Masters Courses Abroad', path: '/study-abroad/blog/best-masters-courses-abroad/' },
        { label: 'Study Abroad Without IELTS', path: '/study-abroad/blog/study-abroad-without-ielts/' },
        { label: 'Book Free Counselling', path: '/study-abroad/book-counselling/' },
      ],
    },
  ],
};

// P1: About absorbs Success Stories (sectioned dropdown). Same URLs.
export const aboutLinks = [
  {
    subtitle: 'About ZAFCO',
    links: [
      { label: 'About ZAFCO Study Abroad', path: '/study-abroad/about-zafco/' },
      { label: 'Why Choose ZAFCO',         path: '/study-abroad/why-choose-zafco/' },
      { label: 'Our Global Partnerships',  path: '/study-abroad/global-partnerships/' },
      { label: 'Events & Webinars',        path: '/study-abroad/events-webinars/' },
      { label: 'Meet Our Counsellors',     path: '/study-abroad/meet-our-counsellors/' },
      { label: 'Media & Press',            path: '/study-abroad/media-press/' },
    ],
  },
  {
    subtitle: 'Success Stories',
    links: [
      { label: 'Student Success Stories', path: '/study-abroad/student-success-stories/' },
      { label: 'Video Testimonials', path: '/study-abroad/video-testimonials/' },
      { label: 'Our Visa Success Rate', path: '/study-abroad/visa-success-rate/' },
    ],
  },
];

export const primaryNavItems = [
  { label: 'Home', path: '/study-abroad/', type: 'link' },
  { label: 'Study Destinations', type: 'mega', dataKey: 'studyDestinations' },
  { label: 'Universities', type: 'mega', dataKey: 'universities' },
  { label: 'Careers & Jobs', type: 'mega', dataKey: 'careersJobs' },
  { label: 'Knowledge Center', type: 'mega', dataKey: 'knowledgeCenter' },
  { label: 'About', type: 'dropdown', dataKey: 'aboutLinks' },
  { label: 'Contact', path: '/contact', type: 'link' },
];

// ─── P2 (Jun 2026): ZAFCO Navigation Standard v1.0 ───
// Feature flag: flip to false to instantly roll back to the P1 flat destinations list + classic mobile drawer.
export const NAV_V2 = true;

// Data-driven flagship Destinations mega menu. Adding a country = one entry here (FC1, NAVIGATION_GOVERNANCE.md).
// Spokes without a `path` render as FUTURE placeholders (non-clickable). Spoke order fixed per Blueprint (MM2).
export const destinationsMega = {
  countries: [
    {
      id: 'newzealand', flag: '🇳🇿', name: 'New Zealand', tagline: 'QS Top-500 unis · Green List PR', badge: 'NEW',
      hub: '/study-abroad/newzealand/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/newzealand/' },
        { label: 'Student Visa Guide', path: '/study-abroad/newzealand/student-visa-guide/' },
        { label: 'Cost of Study & Living', path: '/study-abroad/newzealand/cost-of-study-living/' },
        { label: 'Green List PR Guide', path: '/study-abroad/newzealand/green-list-pr-guide/' },
        { label: 'Scholarships' },
        { label: 'Universities' },
        { label: 'Accommodation' },
        { label: 'Part-time Jobs' },
      ],
    },
    {
      id: 'germany', flag: '🇩🇪', name: 'Germany', tagline: 'Free public unis · 18-mo job visa',
      hub: '/study-abroad/germany/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/germany/' },
        { label: 'Student Visa Guide', path: '/study-abroad/germany/student-visa/' },
        { label: 'Cost of Study', path: '/study-abroad/germany/cost-of-study/' },
        { label: 'APS Certificate', path: '/study-abroad/germany/aps-certificate/' },
        { label: 'Blocked Account', path: '/study-abroad/germany/blocked-account/' },
        { label: 'Scholarships', path: '/study-abroad/germany/scholarships/' },
        { label: 'PR After Study', path: '/study-abroad/germany/pr-after-study/' },
        { label: 'Accommodation', path: '/study-abroad/germany/student-accommodation/' },
      ],
    },
    {
      id: 'uk', flag: '🇬🇧', name: 'United Kingdom', tagline: '2-yr Graduate Route · 90+ unis',
      hub: '/study-abroad/uk/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/uk/' },
        { label: 'Student Visa Guide', path: '/study-abroad/uk/student-visa/' },
        { label: 'Best Universities', path: '/study-abroad/uk/best-universities/' },
        { label: 'Scholarships', path: '/study-abroad/uk/scholarships/' },
        { label: 'Cost of Study & Living' },
        { label: 'PR Pathways' },
      ],
    },
    {
      id: 'canada', flag: '🇨🇦', name: 'Canada', tagline: 'PGWP up to 3 yrs · PR ladder',
      hub: '/study-abroad/canada/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/canada/' },
        { label: 'Student Visa Guide', path: '/study-abroad/canada/student-visa/' },
        { label: 'Scholarships', path: '/study-abroad/canada/scholarships/' },
        { label: 'Cost of Study & Living' },
        { label: 'PGWP & PR Guide' },
      ],
    },
    {
      id: 'australia', flag: '🇦🇺', name: 'Australia', tagline: 'Temp Graduate visa · Go8 unis',
      hub: '/study-abroad/australia/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/australia/' },
        { label: 'Student Visa Guide', path: '/study-abroad/australia/student-visa/' },
        { label: 'Cost of Study & Living' },
        { label: 'Scholarships' },
        { label: 'PR Pathways' },
      ],
    },
    {
      id: 'ireland', flag: '🇮🇪', name: 'Ireland', tagline: 'EU tech hub · 2-yr stay-back',
      hub: '/study-abroad/ireland/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/ireland/' },
        { label: 'Student Visa Guide', path: '/study-abroad/ireland/student-visa/' },
        { label: 'Cost of Study & Living' },
        { label: 'Scholarships' },
      ],
    },
    {
      id: 'dubai', flag: '🇦🇪', name: 'Dubai / UAE', tagline: 'Golden Visa · branch campuses',
      hub: '/study-abroad/dubai/',
      spokes: [
        { label: 'Overview (Hub)', path: '/study-abroad/dubai/' },
        { label: 'Cost of Living & Tuition', path: '/study-abroad/dubai/cost-of-living-tuition/' },
        { label: 'Student Work Rights', path: '/study-abroad/dubai/student-work-rights/' },
        { label: 'Golden Visa Pathways', path: '/study-abroad/dubai/golden-visa-post-study-pathways/' },
        { label: 'Universities', path: '/study-abroad/dubai/universities/' },
        { label: 'Top Courses', path: '/study-abroad/dubai/top-courses-for-residency/' },
      ],
    },
  ],
  tools: [
    { label: 'Compare Destinations', path: '/study-abroad/compare/' },
    { label: 'Cost Calculator', path: '/study-abroad/cost-calculator/' },
    { label: 'Visa Eligibility Checker', path: '/study-abroad/visa-eligibility/' },
  ],
};
